import "./App.css";
import Upload from "./Upload";
function App() {
  return (
    <div className="parent">
      <Upload />
    </div>
  );
}

export default App;
